if (!customElements.get('ap-cover-configurator')) {
  customElements.define('ap-cover-configurator', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.section = document.getElementById(`MainProduct-${this.dataset.section}`);
      this.fields = this.querySelector('.ap-configurator__fields');
      this.abort = new AbortController();
      this.section.addEventListener('change', () => requestAnimationFrame(() => this.update()), { signal: this.abort.signal });
      this.observer = new MutationObserver(() => this.update());
      this.observer.observe(this.fields, { subtree: true, childList: true, attributes: true, attributeFilter: ['disabled', 'aria-disabled'] });
      const price = this.section.querySelector('[id^="price-"]');
      if (price) this.observer.observe(price, { subtree: true, childList: true });
      this.update();
    }
    disconnectedCallback() { this.abort?.abort(); this.observer?.disconnect(); this.ready = false; }
    update() {
      const total = this.fields.querySelector('[data-ap-total]') || this.section.querySelector('.price-item--regular');
      const nativeTotal = this.querySelector('[data-ap-native-total]');
      if (total && nativeTotal && nativeTotal.textContent.trim() !== total.textContent.trim()) nativeTotal.textContent = total.textContent.trim();
      const sticky = this.section.querySelector('[data-ap-sticky-price]');
      if (total && sticky && sticky.textContent.trim() !== total.textContent.trim()) sticky.textContent = total.textContent.trim();
    }
  });
}
